/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_StairsInputs */

const cs_enum_stairs = /** @type {(inputs: Enum_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schodiště`)
};

const en_enum_stairs = /** @type {(inputs: Enum_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stairs`)
};

/**
* | output |
* | --- |
* | "Stairs" |
*
* @param {Enum_StairsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_stairs = /** @type {((inputs?: Enum_StairsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_StairsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_stairs(inputs)
	return cs_enum_stairs(inputs)
});